<template>
  <div class="comment">
    <div class="comment__body" ref="scrollChatMsg">
      <div
        v-for="(msg, index) in commentMsgList"
        :key="index"
        class="comment__item"
      >
        <div class="comment__avatar">
          <img v-if="msg.headImg && msg.headImg.url" :src="msg.headImg.url" />
          <img v-else :src="require('@/assets/imgs/logo.png')" />
        </div>
        <div class="comment__text">
          <!-- <span class="comment__nickname">{{ msg.userName }}：</span>{{ msg.msg }} -->
          <!-- <span class="comment__content">{{ msg.msg }}</span> -->
		  {{ msg.userName }}：{{ msg.msg }}
        </div>
		<!-- <div class="comment__text_test">
          <div class="comment__nickname_test" ref="aaaa">{{ msg.userName }}：</div>
          <span class="comment__content_test">{{ msg.msg }}</span>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
	// this.measure();
  },
  props: {
    commentMsgList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    commentMsgList: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          this.setScroll();
        });
      },
    },
  },
  methods: {
    setScroll() {
      const target = this.$refs.scrollChatMsg;
      if (!target) return;
      target.scrollTop = target.scrollHeight;
    },
	// measure(){
	// 	var str = 'Live like you were dying, Love because you do.';
	// 	str = str.substring(0, str.length);
	// 	// this.$refs.aaaa.html(str);
	// 	var width = this.$refs.aaaa.offsetWidth();
	// 	console.log('comment__nickname_test1:'+width);

	// 	this.$refs.aaaa.$el.html(str);
	// 	this.$refs.aaaa.$el.width(str);
	// 	// var width = this.$refs.aaaa.width();
	// 	// console.log('comment__nickname_test2:'+width);
	// }
  },
};
</script>

<style lang="less" scoped>
.warp() {
  overflow: hidden;
  word-wrap: break-word;
  white-space: pre-wrap;
  word-break: break-word;
}
.scroll() {
  scrollbar-width: none;
  -ms-overflow-style: none;
  overflow-x: hidden;
  overflow-y: auto;
}
.comment {
  color: #ffffff;
  text-align: left;
  box-sizing: border-box;
  padding-left: 5px;
	// background-image: linear-gradient(0,
    //   rgba(0, 0, 0, 1) ,
    //   transparent 
    // );
  &__body {
    height: 100%;
	width: 270px;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    .scroll();
    &::-webkit-scrollbar {
      display: none;
    }
  }
  &__item {
    width: 234px;
    display: flex;
    margin-bottom: 2px;
    // background-color: rgba(47, 47, 47, 0.4);
    border-radius: 11px;
    padding: 2px 8px 2px 8px;
    box-sizing: border-box;
    line-height: 18px;
  }
  &__avatar {
    width: 24px;
    height: 24px;
	min-width: 24px;
	min-height: 24px;
    border-radius: 50%;
	opacity: 0.8;
    > img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
  &__text {
    // flex: 1;
    display: flex;
    box-sizing: border-box;
    padding-left: 12px;
    line-height: 18px;
    font-size: 13px;
    text-shadow: 0px 4px 8px rgba(0, 0, 0, 0.8);
  }
  &__nickname {
    font-weight: bolder;
    height: 18px;
    font-family: "TradeGothicLT-Bold";
  }
  &__content {
    font-weight: 400;
    font-family: "TradeGothicLT";
    // .warp();
  }
  &__text_test{
	display: flex;
    box-sizing: border-box;
    padding-left: 3px;
    line-height: 18px;
    font-size: 13px;
    text-shadow: 0px 4px 8px rgba(0, 0, 0, 0.8);
	visibility: hidden;
  }
  &__nickname_test {
    font-weight: bolder;
    height: 18px;
    font-family: "TradeGothicLT-Bold";
	visibility: hidden;
  }
  &__content_test {
    font-weight: 400;
    font-family: "TradeGothicLT";
	visibility: hidden;
    // .warp();
  }


  &__mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(
      rgba(255, 255, 255, 0.2) 0%,
      transparent 20%
    );
  }
}
</style>